<script>
	import { smsfCapacityTypes } from "../config";
	import { handleNameChange } from "../helpers";

	import FormRow from "./FormRow.svelte";
	import FormColumn from "./FormColumn.svelte";
	import Checkbox from "./Checkbox.svelte";
	import Select from "./Select.svelte";

	export let name;
	export let capacity;
	export let authorisedToAct;
	export let disabled = null;
	export let required = null;
</script>

<FormRow>
	<FormColumn>
		<h3>Self Managed Super Fund Details</h3>
	</FormColumn>
</FormRow>

<FormRow>
	<FormColumn cols="6">
		<label for="name" class:isrequired={required}>Name of superannuation fund</label>
		<input
			{required}
			{disabled}
			maxlength="1000"
			type="text"
			bind:value={name}
			id="name"
			class="form-control"
			on:change={() => (name = handleNameChange(name))} />
	</FormColumn>
	<FormColumn cols="6">
		<label for="capacity">Capacity</label>
		<Select
			{disabled}
			bind:value={capacity}
			id="capacity"
			optionList={smsfCapacityTypes}
			textProperty="name"
			valueProperty="name"></Select>
	</FormColumn>
</FormRow>

<FormRow>
	<FormColumn>
		<Checkbox
			{disabled}
			bind:checked={authorisedToAct}
			label="I am authorised to register on behalf of the superannuation fund"
			{required}
			id="authinst"></Checkbox>
	</FormColumn>
</FormRow>
